<div class="h-100" [style.background]="backgroundImage"></div>
<div class="color-filter"></div>